// import '@babel/polyfill';
require('react-hot-loader/patch');
require('./utils/styles/main.scss');
require('./utils/styles/mui.overrides.scss');
require('../public/shortlogo.png'); // for the fabicon
